var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounterDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 19,
    viewBox: "0 0 353 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M3 3C17.4598 3 17.4598 16 31.9157 16C46.3715 16 46.3755 3 60.8314 3C75.2872 3 75.2912 16 89.747 16C104.203 16 104.203 3 118.663 3C133.123 3 133.123 16 147.578 16C162.034 16 162.034 3 176.494 3C190.954 3 190.954 16 205.414 16C219.874 16 219.874 3 234.329 3C248.785 3 248.789 16 263.249 16C277.709 16 277.709 3 292.169 3C306.628 3 306.628 16 321.084 16C335.54 16 335.544 3 350 3",
    stroke: "#BCD5F3",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterDecor);
export default __webpack_public_path__ + "static/media/counter_decor.e0ffd88902c9f5e4ec63ab9b03abcb27.svg";
export { ForwardRef as ReactComponent };